import React from "react";
import Header from "../components/Header";
import { BsCreditCard, BsWallet , BsPlusLg } from "react-icons/bs";
import naverPay from "../images/naverPay.png";
import kakaoPay from "../images/kakaoPay.png";
import ssPay from "../images/ssPay.png";
import { useTranslation } from 'react-i18next';


export default function OrderPayment(props) {
    const { t } = useTranslation();

    const fn_sel = (ty) => {        
        if(props.checkCard){
            props.checkCard(prevState => ({...prevState , 'payMethod': ty})) 
            props.closeFn()
        }
    }
    return(
        <div className={props.modal?'modalPage':'justPage'}>
            <Header  type={props.modal?'modal':'cart'}  closeFn={props.closeFn} pageTitle={t(`Message.payment_method_select_title`)}/>
            <div className="payMent">
                 <div className="paymentType1">
                    <BsCreditCard className="icon"/>
                    <div className="wr">
                        <p className="tit">카드 간편결제</p>
                        
                     

                        <div className="dfColG20">
                            <div className="dfColG12">
                                <p className="seletedCard">신한카드 1234 1234 **** ****</p>
                                <select name="" id="">
                                    <option value="">{t(`Message.my_order_detail_payment_info_pay_card_quota1`)}</option>
                                    {Array(23).fill(0).map((_,i) => (                                                        
                                        <option value={i+2}>{t(`Message.my_order_detail_payment_info_pay_card_quota2`, {cardQuota: i+2})}</option>
                                    ))} 
                                </select>
                                <p className="cDisa fs12">* 할부는 50,000원 이상만 가능합니다.</p>
                            </div>
                            <ul className="payType1radio">
                                <li>
                                    <input type="radio" name="pay" id="a3" defaultChecked/>
                                    <label htmlFor="a3">신한카드 1234 1234 **** ****</label>
                                </li>
                                <li>
                                    <input type="radio" name="pay" id="a4" />
                                    <label htmlFor="a4">삼성카드 1234 1234 **** ****</label>
                                </li>
                                <li>
                                    <input type="radio" name="pay" id="a5" />
                                    <label htmlFor="a5">현대카드 1234 1234 **** ****</label>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                    <button 
                        type="button" 
                        className="btn40 greenB cFFF"
                        onClick={(e) => window.location.href="/OrderAddCard"}
                    >
                        <BsPlusLg/>카드추가
                    </button>
                </div>
                <div className="paymentType2">
                    <input type="radio" name="pay" id="a1" onClick={(e)=> {fn_sel('card')}} />
                    <label htmlFor="a1">
                        <BsCreditCard className="cOrg"/>
                        {t(`Message.payment_method_select_general_card_pay`)}
                    </label>
                </div>
                <div className="paymentType2">
                    <input type="radio" name="pay" id="a2" onChange={(e)=> {fn_sel('va')}} />
                    <label htmlFor="a2">
                        <BsWallet className="cOrg"/>
                        {t(`Message.payment_method_select_virtual_account`)}
                    </label>
                </div>
                <div className="paymentType2">
                    <input type="radio" name="pay" id="a3" onChange={(e)=> {fn_sel('naverpayCard')}} />
                    <label htmlFor="a3">
                        <img src={naverPay} alt="네이버페이" className="payImg"/>
                        네이버페이
                    </label>
                </div>
                <div className="paymentType2">
                    <input type="radio" name="pay" id="a4" onChange={(e)=> {fn_sel('kakaopay')}} />
                    <label htmlFor="a4">
                        <img src={kakaoPay} alt="카카오페이" className="payImg"/>
                        카카오페이
                    </label>
                </div>
                <div className="paymentType2">
                    <input type="radio" name="pay" id="a5" onChange={(e)=> {fn_sel('samsungpayCard')}} />
                    <label htmlFor="a5">
                        <img src={ssPay} alt="삼성페이" className="payImg"/>
                        삼성페이
                    </label>
                </div>
            </div>
        </div>
    );
};